import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import parse from 'html-react-parser';

import { useParams } from 'react-router-dom';
import useGetEvent from '../../hooks/useGetEvent/useGetEvent';
import useSetPageTitle from '../../hooks/useSetPageTitle/useSetPageTitle';

import Icon from '../../components/Icon/Icon';
import PageBanner from '../../common/PageBanner/PageBanner';
import Spinner from '../../components/Spinner/Spinner';

import styles from './EventPage.module.scss';
import commons from '../../shared/styles/common.module.scss';

const EventPage = () => {
  const { t } = useTranslation();
  const params = useParams();
  const postId = params.eventId;

  const { data, refetch } = useGetEvent(Number(postId), false);

  useSetPageTitle({
    pageTitle: `${data?.title} - ${t('general.website-name')}`,
  });

  React.useEffect(() => {
    if (postId) {
      refetch();
    }
  }, [postId, refetch]);

  return !data ? (
    <Spinner variant='green' />
  ) : (
    <div>
      <PageBanner
        title={data.title}
        imageSrc={data.featured_image}
        imageText={data.title}
      />
      <div className={classNames(styles.eventContainer, commons.container)}>
        <div>
          <h1
            className={classNames(
              styles.eventTitle,
              commons.subSectionHeading,
            )}>
            {data.title}
          </h1>
          <div className={styles.eventContent}>{parse(data.content)}</div>
          <img
            src={data.featured_image}
            alt={data.title}
            className={styles.eventContentImage}
          />
        </div>
        {data.dates.start_date || data.dates.end_date ? (
          <div className={styles.eventDetails}>
            <p className={styles.eventDetailsItem}>
              <span className={styles.eventDetailsItemText}>
                <Icon name='fa-calendar' color='icon-accent' />
                <span>{t('general.date')}:</span>
              </span>
              <span className={styles.eventDetailsItemContent}>
                {data.dates.start_date && <span>{data.dates.start_date}</span>}
                {data.dates.end_date && (
                  <>
                    <span className={styles.eventDetailsItemContentSeparator}>
                      -
                    </span>
                    <span>{data.dates.end_date}</span>
                  </>
                )}
              </span>
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default EventPage;
